import { SignInPage } from "@grafit/frontend-auth/sign-in-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_no_auth/sign-in")({
  component: SignInPage,
});
